<template>

  <div>


    <Row>
      <p class="mb-10">Выберите точку продаж</p>
      <Col :lg="8">
        <Select label="Выберите точку продаж" @on-change="getCashbox()" v-model="checkPoint" class="mb-40">
          <Option v-for="option in points"
                  :key="option.pointId"
                  :value="option.pointId">
            {{option.name}}
          </Option>
        </Select>
      </Col>


    </Row>

    <Row type="flex" style="padding-left: 15px; padding-right: 15px" class="color-grey fs-15 mb-30 desktop_table">
      <Col :lg="5">Наименование кассы</Col>
      <Col :lg="4">Заводской номер</Col>
      <Col :lg="3" class="text-center">Отдел/секция</Col>
      <Col :lg="4" class="text-center">Статус смены</Col>
      <Col :lg="5">Статус автозакрытия</Col>
      <Col :lg="3" class="text-right">Выберите действие</Col>
    </Row>


    <!-- DATA DESKTOP TABLE -->
    <div class="desktop_table">
      <Row type="flex" align="middle" class="card-container mb-24" style="padding: 12px 15px"
           v-for="item in data" v-if="data">
        <Col :lg="5">{{item.name}}</Col>
        <Col :lg="4">{{item.manufacturerNumber}}</Col>
        <Col :lg="3" class="text-center">{{item.pointId}}</Col>
        <Col :lg="4" class="text-center">
          <span v-if="item.shiftStatus === 'CLOSE'">Закрыта</span>
          <span v-else>Смена № {{item.shiftNumber}}, {{formatDateTime(item.shiftOpenDate)}} </span>
        </Col>
        <Col :lg="5">
          <span v-if="item.autocloseStatus === 'DISABLED'">Расписание отключено</span>
          <span v-if="item.autocloseStatus === 'ACTIVE'">Расписание включено / {{formatTime(item.autocloseExecTime)}}</span>
        </Col>
        <Col :lg="3" class="text-right">
          <button @click="getShedule(item.cashId, item.name, item.manufacturerNumber)"
                  class="btn-edit">
            <Icon type="md-create" />
          </button>

          <i-switch v-model='item.checked' v-if="item.autocloseExecTime" @on-change="getStatus(item.checked, item.cashId)"></i-switch>
          <i-switch v-model='item.checked' v-else @on-change="createShedule(item.cashId, item.name, item.manufacturerNumber)"></i-switch>
        </Col>
      </Row>
    </div>


    <!-- DATA MOBILE TABLE -->
    <div class="mobile-table">

      <div v-for="item in data" class="card-container">
        <div>

          <div class="d-flex align-center">
            <h2 style="margin-bottom: 0">{{item.name}}</h2>
            <button @click="getShedule(item.cashId, item.name, item.manufacturerNumber)"
                    class="btn-edit">
              <Icon type="md-create" />
            </button>
          </div>

          <p>Заводской номер: {{item.manufacturerNumber}}</p>
          <p>Отдел/секция: {{item.pointId}}</p>
          <p>Статус смены:
            <span v-if="item.shiftStatus === 'CLOSE'">Закрыта</span>
            <span v-else>item.shiftStatus</span>
          </p>
          <p>Статус автозакрытия:
            <span v-if="item.autocloseStatus === 'DISABLED'">Расписание отключено</span>
            <span v-if="item.autocloseStatus === 'ACTIVE'">Расписание включено / {{formatTime(item.autocloseExecTime)}}</span>
          </p>
        </div>

        <div>
          <i-switch v-model='item.checked' @on-change="getStatus(item.checked, item.cashId)"></i-switch>
        </div>

      </div>
    </div>



    <div v-if="data.length < 1">
      <h5 class="text-center" style="font-weight: normal; margin-top: 100px; margin-bottom: 100px">Нет данных</h5>
    </div>



    <!--EDIT DATE-->
    <Drawer
      class="drawer_modal"
      width="700"
      v-model="modalCard" >
      <h2 class="mb-40">Автозакрытие смены</h2>

      <Form>
        <Row type="flex" gutter="24">
          <Col :xs="24" :sm="24" :md="12" class="mb-24">
            <p class="mb-10 fs-15 color-grey">Наименование кассы</p>
            <Input class="border_30" v-model="schedule.name" disabled="true"/>
          </Col>

          <Col :xs="24" :sm="24" :md="12" class="mb-24">
            <p class="mb-10 fs-15 color-grey">Заводской номер</p>
            <Input class="border_30" v-model="schedule.number" disabled="true"/>
          </Col>

          <Col :xs="24" :sm="24" :md="12" class="mb-40">
            <p class="mb-10 fs-15">Время автозакрытия смены</p>
              <Input type="time" class="border_30"
                     v-model="scheduleTime"
                     :class="{ivuFormItemError : errorTime && scheduleTime === ''}"
              />


          </Col>
        </Row>

        <Row type="flex" align="middle" gutter="24" class="mb-30">
          <Col xs="24" :sm="24" :md="12" class="mb-10">
            <Checkbox type="checkbox" v-model="postEmail"> <span class="fs-15">Отправка Z отчета на email</span> </Checkbox>
          </Col>

          <Col :xs="24" :sm="24" :md="12" class="mb-10">
            <p class="mb-10 fs-15 color-grey">E-mail</p>

            <Input type="email" class="border_30"
                   :class="{ivuFormItemError : errorEmail && scheduleEmail === '' && postEmail}"
                   v-model="scheduleEmail"
                   :disabled="!postEmail"/>
              <div v-if="errorEmail && scheduleEmail === '' && postEmail" class="ivu-form-item-error-tip">Введите E-mail</div>



          </Col>
        </Row>

        <Row type="flex" :gutter="24"  align="middle" justify="end" class="mb-15">
          <Col :xs="24" :sm="24" :md="12"><p class="fs-15 mb-10">Изъятие наличности при автозакрытии смены</p></Col>

          <Col :xs="24" :sm="24" :md="12" class="mb-10">

            <Select v-model="scheduleType">
              <Option v-for="item in cashBack"
                      :key="item.id"
                      :value="item.id">
                {{item.name}}
              </Option>
            </Select>
          </Col>
        </Row>


        <Row type="flex" :gutter="24" align="middle" justify="end">
          <Col :xs="24" :sm="24" :md="12"><p class="fs-15 mb-10">Сумма остатка кассы при закрытии смены</p></Col>

          <Col :xs="24" :sm="24" :md="12" class="mb-10">
            <Input class="border_30"
                   :class="{ivuFormItemError : errorType && scheduleAmount === '' && scheduleType === '20'}"
                   v-model="scheduleAmount"
                   :disabled="scheduleType != 20" />
            <div v-if="errorType && scheduleAmount === '' && scheduleType === '20'" class="ivu-form-item-error-tip">Заполните поле</div>
          </Col>
        </Row>


        <div class="ls_drawer_footer" style="margin-top: 20px">
          <Button style="margin-right: 8px" type="error" @click="modalCard = false"><Icon type="md-close"/></Button>
          <Button style="margin-right: 8px" type="success" @click="postShedule(schedule)"><Icon type="md-checkmark" /></Button>
        </div>
      </Form>



    </Drawer>

  </div>


</template>

<script>

    import {server_addr} from "../../http";



    export default {
        data() {
            return {
                validForm: false,
                modalCard: false,
                autoStatus: '',
                checkPoint: '',
                scheduleStatus: '',
                points: [],
                data: [],


                schedule: [],
                postEmail: false,

                scheduleType: '',
                scheduleEmail: '',
                scheduleTime: '',
                scheduleAmount: '',

                errorEmail: false,
                errorTime: false,
                errorType: false,

                cashBack: [
                    {
                        name: 'Полное изъятие',
                        id: '10'
                    },
                    {
                        name: 'Частичное изъятие',
                        id: '20'
                    },
                    {
                        name: 'Без изъятия',
                        id: '30'
                    },

                ],

            };
        },

        // Загружаем данные для таблицы
        methods: {
            getStore: function () {
                this.loading = true;
                let url = server_addr + "/proxy_/wcadmin/v1/points";
                this.$http
                    .get(url)
                    .then(result => {
                        this.checkPoint = result.data[0].pointId;
                        this.points = result.data;

                        this.getCashbox();
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getCashbox: function () {
                let url = server_addr + "/proxy_/wcadmin/v1/points/" + this.checkPoint + "/cashboxes";
                this.$http
                    .get(url, {
                        params: {
                            returnAutoclose: true,
                            returnShift: true
                        }
                    })
                    .then(result => {
                        result.data.forEach(item => {
                            if(item.autocloseStatus === 'ACTIVE') {
                                item.checked = true;
                            }
                            else {
                                item.checked = false;
                            }
                        });
                        this.data = result.data;
                    })

            },
            getStatus: function (id, cash) {
                let state;
                if(id === true) {
                    state = 'ACTIVE'
                }
                if(id === false) {
                    state = 'DISABLED'
                }
                let url = server_addr + "/proxy_/autoclose/v1/cashboxes/" + cash + "/scheduleStatus";
                this.$http
                    .put(url , {
                        status: state
                    })
                    .then(result => {
                        this.data.forEach(item => {
                            if(item.cashId === cash) {
                                item.autocloseStatus = result.data.status
                            }
                        })
                    })

            },

            getShedule: function(cash, cashname, number) {
                this.schedule.cashId = cash;
                this.schedule.name = cashname;
                this.schedule.number = number;
                let url = server_addr + "/proxy_/autoclose/v1/cashboxes/" + cash + "/schedule";
                this.$http
                    .get(url)
                    .then(result => {
                        this.scheduleTime = this.formatTime(result.data.autocloseExecTime);
                        if(result.data.email) {
                            this.postEmail = true;
                        }
                        this.scheduleEmail = result.data.email;
                        this.scheduleType = result.data.withdrawalType.code;
                        this.schedule.amount = result.data.amount;
                    })
                    .finally(() => {
                        this.modalCard = true;
                })
            },

            createShedule: function(cash, cashname, number) {
                this.schedule.cashId = cash;
                this.schedule.name = cashname;
                this.schedule.number = number;
                // this.schedule.time = '00:00:00';
                this.modalCard = true;
            },

            postShedule: function() {
                if(this.postEmail === true && this.scheduleEmail === '') {
                    this.errorEmail = true;
                }
                else if (this.scheduleTime === '') {
                    this.errorTime = true;
                }

                else if (this.scheduleType === '20' &&  this.scheduleAmount === '') {
                    this.errorType = true;
                }

                else {
                    this.errorEmail = false;
                    let url = server_addr + "/proxy_/autoclose/v1/cashboxes/schedule";
                    this.$http
                        .post(url, {
                            "autocloseExecTime": this.scheduleTime,
                            "cashId": this.schedule.cashId,
                            "email": this.scheduleEmail,
                            "withdrawalType": this.scheduleType,
                            "amount": this.scheduleAmount
                        })
                        .then(result => {
                            this.data.forEach(item => {
                                if(item.cashId === result.data.cashId) {
                                    item.autocloseExecTime = result.data.autocloseExecTime
                                }
                            })
                        })
                        .finally(() => {
                            this.modalCard = false;

                        })
                }

            },

            formatTime: function(time) {
                if (time) {
                    return time.slice(0, 5);

                }
                return "";
            },
            formatDateTime: function (datetime) {
                if (datetime) {
                    let datetimeInst = new Date(Date.parse(datetime));
                    return (
                        datetimeInst.toLocaleDateString() +
                        " " +
                        datetimeInst.toLocaleTimeString()
                    );
                }
                return "";
            }





        },
        mounted: function () {
            this.getStore();
        }
    };


</script>

<style scoped>
  .btn-edit {
    box-shadow: none;
    background: transparent;
    border: none;
    color: #DEDEDE;
    margin-right: 12px;
    padding: 12px;
    transition: 0.4s ease;
    cursor: pointer;
  }
  .btn-edit:hover {
    color: #c2c2c2
  }
  .btn-edit:active, .btn-edit:focus {
    border: none;
    outline: none;
  }

  .ivuFormItemError {
    border: 1px solid #ed4014;
  }
  .ivu-form-item-error-tip {
    padding-left: 24px;
  }

  @media screen and (max-width: 991px) {
    .btn-edit {
      padding: 4px;
      margin-right: 0;
      margin-left: 8px;
    }
    .btn-edit i {
      font-size: 18px;
    }
  }

</style>




// WEBPACK FOOTER //
// src/apps/cash/autoClosingShift.vue